import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBM: CultureInfo = {
  name: 'es-BM',
  displayName: 'español (Bermudas)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BM',
  parent: CultureInfoEs
};
